import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Popconfirm } from 'antd'
import { compose } from 'ramda'
import { classNames } from 'utils/utils'

import withStyle from './ChecPopConfirm.style'

const ChecPopConfirm = (props) => {
  const { showConfirm, children, cancelType, onConfirm, className } = props
  const [visible, setVisiblity] = useState(false)
  const confirm = () => {
    setVisiblity(false)
    onConfirm()
  }

  const cancel = () => {
    setVisiblity(false)
  }
  const handleVisibleChange = (value) => {
    if (!value) {
      setVisiblity(value)
      return
    }
    if (!showConfirm) {
      confirm()
    } else {
      setVisiblity(value)
    }
  }
  const popConfirmClassNames = classNames('chec-popconfirm', {
    [`cancel-${cancelType}`]: cancelType,
  })

  return (
    <Popconfirm
      {...props}
      className={className}
      overlayClassName={popConfirmClassNames}
      visible={visible}
      onVisibleChange={handleVisibleChange}
      onCancel={cancel}
      onConfirm={confirm}
    >
      {children}
    </Popconfirm>
  )
}

ChecPopConfirm.defaultProps = {
  showConfirm: true,
  className: null,
  cancelType: null,
}

ChecPopConfirm.propTypes = {
  showConfirm: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onConfirm: PropTypes.func.isRequired,
  cancelType: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.object,
    PropTypes.string,
  ]),
}

export default compose(withStyle)(ChecPopConfirm)
